import type { MathOperation } from '../math-operation';

export class MathOperationRef {
  constructor(
    readonly mathOperation: MathOperation,
  ) {}

  destroy() {}

  viewBoxUpdated(width: number, height: number) {
    // this._mathExpressionsService.
  }
}
